import React, {useState, useEffect} from 'react';
import $ from 'jquery';

const Layerslide = ({images, faviconImage, data}) => {

  useEffect(() => {

    if(typeof data.faviconImage !== "undefined"){
      setFavicon(data.faviconImage);
      setLayerslide(data.title, data.subTitle, data.layerSlideImages, data.titleColor, data.subTitleColor, data.titleAlign, data.autoRotate);
    }

  }, [data]);

  const setFavicon = (faviconImg) => {
    console.log(faviconImg);
    var favicon = document.getElementById('favicon');
    favicon.href = faviconImg;
  };

  const setLayerslide = (title, subtitle, images, titleColor, subTitleColor, titleAlign, autoRotate) => {

    let imagesLi = '';

    images.forEach((image, index) => {
      imagesLi = imagesLi + '<li><img src="'+image.url+'" alt=""/></li>';
    });

    $("#slide_img_div").html(imagesLi);

    let sliderCount = $("#slider").find(".slider-img li img").length;
    let sliderImg = $("#slider").find(".slider-img");
    let sliderArrow = sliderCount > 1 ? `<ul class="slider-arrow"><li class="arrow-left" role="button"><i class="fas fa-chevron-left"></i></li><li class="arrow-right" role="button"><i class="fas fa-chevron-right"></i></li></ul>` : ``;
    let sliderDotLi = "";
    for (let i = 0; i < sliderCount; i++) {
      sliderDotLi += `<li><i class="fas fa-circle"></i></li>`;
    }

    let sliderText = "<div class='main_div' style='justify-content: "+titleAlign+";'><div class='main_title_div' style='text-align: "+titleAlign+" !important;'><span style='color:"+titleColor+"'>"+title+"</span><p class='subtitleslider'><span style='color:"+subTitleColor+" !important'>"+subtitle+"</span></p></div></div>";
    let sliderDot = `<ul class="slider-dot" style="display:none;">${sliderDotLi}</ul>`;
    $("#slider").append(sliderText + sliderArrow + sliderDot);

    let activeDefaultCount = $(".slider-dot li.active").length;
    if (activeDefaultCount != 1) {
      $(".slider-dot li")
        .removeClass()
        .eq(0)
        .addClass("active");
    }
    let sliderIndex = $(".slider-dot li.active").index();
    sliderImg.css("left", -sliderIndex * 100 + "%");

    // switch between images
    function sliderPos() {
      sliderImg.css("left", -sliderIndex * 100 + "%");
      $(".slider-dot li")
        .removeClass()
        .eq(sliderIndex)
        .addClass("active");
    }

    $(".arrow-right").click(function() {
      sliderIndex >= sliderCount - 1 ? (sliderIndex = 0) : sliderIndex++;
      sliderPos();
    });

    $(".arrow-left").click(function() {
      sliderIndex <= 0 ? (sliderIndex = sliderCount - 1) : sliderIndex--;
      sliderPos();
    });

    $(".slider-dot li").click(function() {
      sliderIndex = $(this).index();
      sliderPos();
    });

    if(images.length>0 && parseInt(autoRotate)===1){
      let goSlider = setInterval(() => {
        $(".arrow-right").click();
      }, 3000);

      $("#slider").on({
        mouseenter: () => {
          clearInterval(goSlider);
        },
        mouseleave: () => {
          goSlider = setInterval(() => {
            $(".arrow-right").click();
          }, 3000);
        }
      });
    }
  };

  return (
    <div className="slider-wrapper" id="slider">
      <ul className="slider-img" id="slide_img_div">
      </ul>
    </div>
  );

};

export default Layerslide;
